module.exports = __webpack_public_path__ + "img/4.d732b0b7.webp";